export enum EmailSettingsInteractions {
  REMOVED = 'Removed',
  ADDED = 'Added',
  CHANGED = 'Changed',
}
